import { Injectable } from '@angular/core';

import { catchError, map } from 'rxjs/operators';
import { GetFilter, GetPagination } from '@shared/interfacres/request-related';
import { Observable } from 'rxjs';
import { BaseApiService } from '@data-access/common/base-api.service';
import { TracksWithPagination } from '@shared/interfacres/track';
import { PlaylistsWithPagination } from '@shared/interfacres/playlist';

@Injectable({providedIn: 'root'})
export class PlaylistsService extends BaseApiService {
  getPlaylists(pagination: GetPagination): Observable<PlaylistsWithPagination> {

    const apiUrl = `${this.apiUrl}/playlists?page=${pagination.page}&limit=${pagination.pageSize}`;

    return this._httpClient.get<PlaylistsWithPagination>(apiUrl).pipe(
      map((response: PlaylistsWithPagination) => this.returnResponseData(response)),
      catchError(this.handleError)
    )
  }

  getTracks(playlistId: number, pagination: GetPagination, sort: GetFilter): Observable<TracksWithPagination> {

    const apiUrl = `${this.apiUrl}/playlists/${playlistId}/tracks?page=${pagination.page}&limit=${pagination.pageSize}&sortBy=${sort.query}&sortDirection=${sort.order}`;
    return this._httpClient.get<PlaylistsWithPagination>(apiUrl).pipe(
      map((response: PlaylistsWithPagination) => this.returnResponseData(response)),
      catchError(this.handleError)
    )
  }

}
